import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "./supabaseClient";

function randomToken(n = 24) {
  const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from({ length: n }, () => chars[Math.floor(Math.random() * chars.length)]).join("");
}

export default function InviteTester() {
  const { state } = useLocation();
  const gameId = state?.gameId;
  const [email, setEmail] = useState("");
  const [link, setLink] = useState("");

  const invite = async () => {
    if (!gameId || !email) return;
    const token = randomToken();

    // 1) Create invite only (PENDING)
    const { error } = await supabase
      .from("invites")
      .insert({ game_id: gameId, email, token });

    if (error) {
      console.error("Failed to create invite:", error);
      alert("Failed to create invite");
      return;
    }

    // 2) Shareable invite link (auto-accepts when opened)
    const l = `${window.location.origin}/play?invite=${token}`;
    setLink(l);
  };


  return (
    <div className="p-6">
      <h1 className="text-white text-xl mb-3">Invite tester</h1>
      <input className="px-3 py-2 rounded bg-[#222] text-white border border-[#333] w-full mb-3" placeholder="email@domain.com" value={email} onChange={e => setEmail(e.target.value)} />
      <button className="px-3 py-1.5 rounded-lg text-white border border-[#8338ec] bg-[#8338ec]/20 hover:bg-[#8338ec]" onClick={invite}>Generate link</button>
      {link && (
        <div className="text-white mt-3 text-sm">
          Share this link: <a className="underline text-[#93c5fd]" href={link}>{link}</a>
        </div>
      )}
    </div>
  );
}
